<script lang="ts">
  import { setContext } from 'svelte';
  import { Stack } from '@athena-lib/Stack';
  import { contextKey, type AccordionProps, type AccordionContext } from './types';

  const { children, singleOpen, space, action, actionArg }: AccordionProps = $props();
  let openHeadings: string[] = $state([]);
  const context: AccordionContext = {
    toggle: (heading) => {
      const idx = openHeadings.indexOf(heading);
      if (idx !== -1) {
        openHeadings.splice(idx, 1);
      } else {
        if (singleOpen) {
          openHeadings = [];
        }
        openHeadings.push(heading);
      }
    },
    isOpen: (heading) => {
      const idx = openHeadings.indexOf(heading);
      return idx !== -1;
    },
  };
  setContext(contextKey, context);
</script>

<Stack {space} dividers="default" dividerAboveAndBelow {action} {actionArg}>
  {@render children()}
</Stack>
